import styled from "styled-components";
import { ExtensionBody, ExtensionSmall } from "app/popleads/components/ui-kit/Text";
import { colors } from "app/popleads/components/ui-kit/colors";

export const StyledCardHeader = styled(ExtensionSmall)`
    color: ${colors.neutral[800]};
    display: flex;
`;

export const StyledCardContent = styled(ExtensionBody)`
    color: ${({ variant }) => (variant ? colors[variant][800] : colors.neutral[800])};
    display: flex;
    font-weight: 500;
`;

export const StyledCardFooter = styled(ExtensionSmall)`
    color: ${colors.neutral[500]};
    display: flex;
    font-size: 11px;
`;

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 8px 12px;
`;

export const StyledTaskListHeader = styled(ExtensionBody)`
    color: ${colors.neutral[800]};
    display: flex;
    font-size: 12px;
    font-weight: 500;
    align-items: center;
    justify-content: space-between;
`;

export const ImportantTaskIcon = styled.div`
    color: ${colors.danger[900]};
    font-weight: 600;
    font-size: 16px;
    padding: 0px 4px;
`;

export const TaskColorIcon = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
`;

export const StyledTaskListContent = styled(StyledCardContent)`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    overflow: hidden;
`;

export const StyledTaskListItemType = styled(ExtensionSmall)`
    color: ${colors.neutral[800]};
    display: flex;
`;

export const StyledTaskListItemContent = styled(ExtensionBody)`
    font-weight: 400;
    padding-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
    word-wrap: break-word;
    max-height: 3em;
    line-height: 1.4;

    * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: inline;
    }

    ul {
        margin: 2px 0;
        padding-left: 16px;
        list-style-type: disc;
        display: block;
    }

    ol {
        margin: 2px 0;
        padding-left: 16px;
        list-style-type: decimal;
        display: block;
    }

    li {
        margin: 1px 0;
        line-height: 1.4;
        display: list-item;
        overflow: visible;
        text-overflow: initial;
        white-space: normal;
    }

    ul ul,
    ol ol,
    ul ol,
    ol ul {
        margin: 1px 0;
        padding-left: 12px;
    }

    strong {
        font-weight: 600;
        display: inline;
    }

    em {
        font-style: italic;
        display: inline;
    }
`;
